import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FAQ } from '../components/FAQ';
import { Calendar, Search, Wrench, CheckCircle, Check, ExternalLink } from 'lucide-react';
export function Services() {
  const packages = [{
    name: 'Bronze',
    title: 'One-Year Repair Service',
    subtitle: '1 Appliance',
    price: '£99',
    image: 'https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?w=800&q=80',
    imageAlt: 'Engineer repairing washing machine in customer kitchen - diagnostics and repair',
    features: ['12 months of engineer callouts and diagnostics', 'Labour included for repairs', 'Standard parts fitted when available', 'Quick booking process', 'UK-based support team'],
    paymentLink: 'https://buy.stripe.com/your-bronze-link'
  }, {
    name: 'Silver',
    title: 'One-Year Repair Service',
    subtitle: 'TV + Set-Top Box',
    price: '£120',
    image: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?w=800&q=80',
    imageAlt: 'Family watching television in living room - TV repair and diagnostics service',
    features: ['Fast response for TV faults', 'Connection issue diagnostics', 'Engineer visits arranged promptly', 'Friendly support every step', '12 months of service'],
    paymentLink: 'https://buy.stripe.com/your-silver-link',
    featured: true
  }, {
    name: 'Gold',
    title: 'Two-Year Repair Service',
    subtitle: '1 Appliance',
    price: '£150',
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80',
    imageAlt: 'Engineer repairing fridge in customer utility room - appliance diagnostics and maintenance',
    features: ['Extended 24-month engineer support', 'Diagnostics and repairs included', 'Standard parts fitted when available', 'Priority booking for full term', 'Dedicated support line'],
    paymentLink: 'https://buy.stripe.com/your-gold-link'
  }];
  const steps = [{
    icon: Calendar,
    title: 'Book',
    description: 'Schedule your visit'
  }, {
    icon: Search,
    title: 'Diagnose',
    description: 'Identify the issue'
  }, {
    icon: Wrench,
    title: 'Repair',
    description: 'Fix the problem'
  }, {
    icon: CheckCircle,
    title: 'Test',
    description: 'Verify it works'
  }];
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-730">
      <Header data-id="element-731" />
      <main className="flex-grow" data-id="element-732">
        <section className="py-20 bg-gradient-to-br from-[#0D7377] to-[#14919B] text-white" data-id="element-733">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-734">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-735">
              Our Repair Services
            </h1>
            <p className="text-xl text-gray-100" data-id="element-736">
              Fast, professional diagnostics and repairs for household
              appliances
            </p>
          </div>
        </section>
        <section className="py-16 bg-white" data-id="element-737">
          <div className="max-w-6xl mx-auto px-4" data-id="element-738">
            <div className="text-center mb-12" data-id="element-739">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-740">
                How Our Process Works
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-741">
                We follow a simple, proven process to get your appliances
                working again
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16" data-id="element-742">
              {steps.map((step, index) => <div key={index} className="text-center" data-id="element-743">
                  <div className="relative mb-4" data-id="element-744">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0D7377] rounded-full" data-id="element-745">
                      <step.icon className="text-white" size={28} data-id="element-746" />
                    </div>
                    {index < steps.length - 1 && <div className="hidden md:block absolute top-8 left-[60%] w-full h-0.5 bg-[#8FB996]" data-id="element-747"></div>}
                  </div>
                  <h3 className="font-semibold text-lg mb-1 text-gray-900" data-id="element-748">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-749">{step.description}</p>
                </div>)}
            </div>
          </div>
        </section>
        <section className="py-16 bg-gray-50" data-id="element-750">
          <div className="max-w-7xl mx-auto px-4" data-id="element-751">
            <div className="text-center mb-12" data-id="element-752">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-753">
                Choose Your Service Package
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-754">
                Select the package that best fits your needs. All packages
                include professional diagnostics and repairs.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-755">
              {packages.map((pkg, index) => <div key={index} className={`bg-white rounded-2xl shadow-lg overflow-hidden transition-transform hover:scale-105 ${pkg.featured ? 'ring-2 ring-[#E8956B]' : ''}`} data-id="element-756">
                  {pkg.featured && <div className="bg-[#E8956B] text-white text-center py-2 font-semibold text-sm" data-id="element-757">
                      MOST POPULAR
                    </div>}
                  <div className="relative h-48 overflow-hidden" data-id="element-758">
                    <img src={pkg.image} alt={pkg.imageAlt} className="w-full h-full object-cover" data-id="element-759" />
                    <div className="absolute top-4 left-4 bg-white px-3 py-1 rounded-full" data-id="element-760">
                      <span className="text-[#0D7377] font-bold text-sm" data-id="element-761">
                        {pkg.name}
                      </span>
                    </div>
                  </div>
                  <div className="p-8" data-id="element-762">
                    <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-763">
                      {pkg.title}
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-764">{pkg.subtitle}</p>
                    <div className="mb-6" data-id="element-765">
                      <span className="text-4xl font-bold text-[#0D7377]" data-id="element-766">
                        {pkg.price}
                      </span>
                    </div>
                    <ul className="space-y-3 mb-8" data-id="element-767">
                      {pkg.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-2" data-id="element-768">
                          <Check className="text-[#8FB996] flex-shrink-0 mt-0.5" size={20} data-id="element-769" />
                          <span className="text-gray-700 text-sm" data-id="element-770">
                            {feature}
                          </span>
                        </li>)}
                    </ul>
                    <a href={pkg.paymentLink} target="_blank" rel="noopener noreferrer" className={`block w-full text-center px-6 py-4 rounded-lg font-semibold transition-colors shadow-md hover:shadow-lg flex items-center justify-center gap-2 ${pkg.featured ? 'bg-[#E8956B] text-white hover:bg-[#D67D54]' : 'bg-[#0D7377] text-white hover:bg-[#14919B]'}`} data-id="element-771">
                      <ExternalLink size={20} data-id="element-772" />
                      Buy Now
                    </a>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        <FAQ data-id="element-773" />
      </main>
      <Footer data-id="element-774" />
    </div>;
}